import { Grid, Typography } from '@mui/material';

// Reusable component for individual stats
const Stat = ({ label, value }) => (
  <Grid item>
    <Typography sx={{ fontSize: 10, color: '#9e9e9e' }}>{label}</Typography>
    <Typography sx={{ fontSize: 11, fontWeight: 500 }}>{value}</Typography>
  </Grid>
);

/**
 * BookingMetaDataCard component to display booking metadata in a structured format.
 * @param {Object} props
 * @returns JSX.Element
 */
export default function BookingMetaDataCard({ title, date, revenue, rooms, adr }) {
  return (
    <Grid container direction="column" spacing={0.5}>
      {/* Title */}
      <Grid item>
        <Typography sx={{ fontSize: 11, color: '#9e9e9e' }}>{title}</Typography>
      </Grid>

      {/* Date */}
      <Grid item>
        <Typography sx={{ fontSize: 11 }}>{date}</Typography>
      </Grid>

      {/* Metrics */}
      <Grid item>
        <Grid container spacing={5}>
          <>
            {revenue !== undefined && <Stat label="Rev" value={Number(revenue.toFixed(2))} />}

            {rooms !== undefined && <Stat label="Rooms" value={Number(rooms.toFixed(2))} />}

            {adr !== undefined && <Stat label="ADR" value={Number(adr.toFixed(2))} />}
          </>
        </Grid>
      </Grid>
    </Grid>
  );
}
